import React from 'react';
import PropTypes from 'prop-types';

import { ProgressBar } from '../Base';
import { getFormattedNumber, getNumberVariant } from '../Base/Number';

const getMarkerLabel = (variant, averageScore) => {
  if (variant === 'full') {
    return `คะแนนเฉลี่ย: ${averageScore}`;
  }
  return averageScore;
};

const ScoreBar = ({ width, averageScore, score, fullScore, variant, scoreVariant, ...props }) => (
  <ProgressBar
    width={width}
    maxValue={fullScore}
    value={getFormattedNumber(score, getNumberVariant(scoreVariant))}
    marker={{
      label: getMarkerLabel(
        variant,
        getFormattedNumber(averageScore, getNumberVariant(scoreVariant))
      ),
      percent: (averageScore / fullScore) * 100,
    }}
    showLabel={variant === 'full'}
    {...props}
  />
);

ScoreBar.propTypes = {
  width: PropTypes.string,
  averageScore: PropTypes.number,
  score: PropTypes.number,
  fullScore: PropTypes.number,
  variant: PropTypes.oneOf(['short', 'full']),
};

ScoreBar.defaultProps = {
  variant: 'short',
};

export default ScoreBar;
